<template>
  <div class="az" v-show="flag">
    <div class="AZ">{{ sortFlag ? 'Z - A' : 'A - Z' }}</div>
  </div>
</template>

<script>
export default {
  name: 'AZ',
  data() {
    return {
      flag: false
    }
  },
  props: {
    sortFlag: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.az {
  .AZ {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40%;
    min-width: 240px;
    height: 120px;
    text-align: center;
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    border-radius: 5px;
    overflow: hidden;
    z-index: 100;
    line-height: 120px;
    max-width: 400px;
  }
}
</style>
